import { parse } from "date-fns";

import { LiveChatRole } from "constants/role";
import { ILivechatGroup } from "interfaces/entities/livechat";
import {
  IIntegration,
  ILiveChatImport,
  ILiveChatImportDiff,
  ILiveChatSelectiveImport,
  ILiveChatSelectiveImportStartPayload,
} from "store/entities/integrations";
import { ILiveChatAgent, IRawLiveChatAgent } from "store/views/agents";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserialize(integration: any): IIntegration {
  return {
    id: integration.ID,
    type: integration.type,
    licenseId: integration.licenseID,
    externalId: integration.externalID,
    import: integration.import,
    importModifiedSince: integration?.importModifiedSince,
    flags: integration.flags,
    createdAt: parse(integration.createdAt),
    createdBy: integration.createdBy,
    createdByType: integration.createdByType,
    updatedAt: parse(integration.uploadedAt),
    updatedBy: integration.updatedBy,
    settings: integration.settings,
    active: integration.active ?? true,
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeList(integrations: any[]): IIntegration[] {
  return integrations.map(deserialize);
}

const permissionsMap = {
  owner: LiveChatRole.Owner,
  viceowner: LiveChatRole.ViceOwner,
  administrator: LiveChatRole.Admin,
  normal: LiveChatRole.Normal,
};
function deserializeLiveChatAgent(agent: IRawLiveChatAgent): ILiveChatAgent {
  return {
    ...agent,
    id: agent.email,
    permission: permissionsMap[agent.permission],
  };
}

export function deserializeLiveChatAgents(agents: IRawLiveChatAgent[]): ILiveChatAgent[] {
  return agents.map(deserializeLiveChatAgent);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeLiveChatImport(data: any): ILiveChatImport {
  return data;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeLiveChatSelectiveImport(data: any): ILiveChatSelectiveImport {
  return data;
}

export function deserializeLiveChatSelectiveImportStart(
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  types: any
): { data: ILiveChatSelectiveImport } & ILiveChatSelectiveImportStartPayload {
  return {
    data,
    types,
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeLiveChatImportDiff(data: any): ILiveChatImportDiff {
  return data;
}

export function deserializeLivechatGroups(groups: Record<string, ILivechatGroup>): ILivechatGroup[] {
  return Object.keys(groups).map(groupIdx => ({
    id: String(groups[groupIdx].id),
    name: groups[groupIdx].name,
  }));
}
